import {
  Component,
  computed,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  WHAssetsENUM,
  WHImgAuthHeaderModule,
} from '@workheld/workheld-shared-lib';
import { AppSharedModule } from 'src/app/app-shared/app-shared.module';
import { WorkerLookupStore } from 'src/app/signal-stores/worker-lookup.store';

export interface WorkerDisplayModel {
  name: string;
  smallerAvatarURL: string;
  extId: string;
  workerDetailRouterLink: string[] | null;
}

@Component({
  selector: 'ng-bee-worker-static-data',
  templateUrl: './worker-static-data.component.html',
  styleUrls: ['./worker-static-data.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    TranslateModule,
    WHImgAuthHeaderModule,
    AppSharedModule,
  ],
})
export class WorkerStaticDataComponent {
  private readonly workerStore = inject(WorkerLookupStore);
  private readonly router = inject(Router);

  detailURL = input<string>('');
  isSimple = input(false);
  isRemoveable = input(false);
  withNameLabel = input(false);
  nameLabel = input('worker.model.root');
  withDetailPageNav = input(false);
  showLoginInfo = input(true);
  workerId = input('');
  isAvatar = input(false);

  onRemoveClick = output<boolean>();

  workerDisplay = computed<WorkerDisplayModel | null>(() => {
    const url = this.detailURL();
    if (!url) return null;

    const entry = this.workerStore.workerByUrl()[url];
    if (!entry || !entry.name) return null;

    const routerLink = this.workerId() ? ['/workers', this.workerId()] : null;

    if (!this.showLoginInfo() && entry.workerDOM) {
      return {
        name: entry.workerDOM.name,
        smallerAvatarURL: entry.workerDOM.smallerAvatarURL,
        extId: entry.workerDOM.extId,
        workerDetailRouterLink: routerLink,
      };
    }

    return {
      name: entry.name,
      smallerAvatarURL: entry.avatarUrl,
      extId: entry.extId,
      workerDetailRouterLink: routerLink,
    };
  });

  personImgJPG = WHAssetsENUM.personImgJPG as string;

  constructor() {
    effect(() => {
      const url = this.detailURL();
      if (url) {
        this.workerStore.loadWorker(url);
      }
    });
  }

  navigate(): void {
    const id = this.workerId();
    if (id) {
      this.router.navigate(['/workers', id]);
    }
  }

  removeChip(): void {
    this.onRemoveClick.emit(true);
  }
}
